export default __webpack_public_path__ + "static/media/kitchen3-before2-1440w.c6de245a.png";